import React from "react";
import Category from "./Category";

const Categories = ({toggleModal, categoryList}) => {

    return (
        <div className='flex h-full justify-around items-center'>
            {categoryList?.map((item, index) =>
                <Category key={index} toggleModal={toggleModal} categoryElementInfo={{
                    icon: item?.Icon,
                    name: item?.name,
                    text: item?.Title,
                    menuCategoryId: item?.MenuCategoryId
                }}/>
            )}
        </div>
    )
}

export default Categories;